export const rewardPrizeTypeEnum = {
  GAMES: 'GAMES',
  POINTS: 'POINTS',
};

export const achievementCategoryEnum = {
  PLAYED_GAMES: 'PLAYED_GAMES',
  CORRECT_ANSWERS: 'CORRECT_ANSWERS',
  SUCCESSFUL_FRIEND_INVITATIONS: 'SUCCESSFUL_FRIEND_INVITATIONS',
  STREAK_DAYS: 'STREAK_DAYS',
};

export const achievementConfiguration = {
  PLAYED_GAMES_1: { image: '/static/images/achievements/follower.svg' },
  PLAYED_GAMES_2: { image: '/static/images/achievements/enthusiast.svg' },
  PLAYED_GAMES_3: { image: '/static/images/achievements/super_fan.svg' },
  PLAYED_GAMES_4: { image: '/static/images/achievements/fanatic.svg' },
  CORRECT_ANSWERS_1: { image: '/static/images/achievements/magazine_reader.svg' },
  CORRECT_ANSWERS_2: { image: '/static/images/achievements/talent_scout.svg' },
  CORRECT_ANSWERS_3: { image: '/static/images/achievements/media_expert.svg' },
  SUCCESSFUL_FRIEND_INVITATIONS_1: { image: '/static/images/achievements/networker.svg' },
  SUCCESSFUL_FRIEND_INVITATIONS_2: { image: '/static/images/achievements/influencer.svg' },
  STREAK_DAYS_1: { image: '/static/images/achievements/streak_warrior.svg' },
  STREAK_DAYS_2: { image: '/static/images/achievements/streak_hero.svg' },
  STREAK_DAYS_3: { image: '/static/images/achievements/streak_master.svg' },
};
